import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Mail, Instagram, Linkedin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative z-[2] border-t border-white/10 bg-black"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-5">
            <h2 className="font-display text-4xl sm:text-5xl font-black tracking-tighter leading-[0.95]">
              Ready to scale
              <br />
              your <span className="text-[#ccff00]">growth</span>?
            </h2>
            <p className="mt-5 text-zinc-400 max-w-md leading-relaxed">
              Performance marketing for ambitious European brands. Meta Ads,
              Google Ads, SEO — measured by revenue, not impressions.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 bg-[#ccff00] hover:bg-[#d4ff33] text-black px-5 py-3 font-bold tracking-tight transition group"
            >
              Start a project
              <ArrowUpRight className="h-4 w-4 transition group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
              Navigate
            </p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link
                  to="/services"
                  className="text-zinc-300 hover:text-[#ccff00] transition"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/case-studies"
                  className="text-zinc-300 hover:text-[#ccff00] transition"
                >
                  Case Studies
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-zinc-300 hover:text-[#ccff00] transition"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-zinc-300 hover:text-[#ccff00] transition"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
              Headquarters
            </p>
            <div className="mt-4 space-y-3 text-sm text-zinc-400 leading-relaxed">
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 text-[#ccff00] flex-shrink-0" />
                <span>
                  <span className="text-white font-medium block">
                    BRIGHT SOLUTIONS EUROPE sp. z o.o.
                  </span>
                  ul. Hoża 86 / 410
                  <br />
                  00-682 Warszawa, Poland
                </span>
              </div>
              <div className="flex items-start gap-2">
                <Mail className="h-4 w-4 mt-0.5 text-[#ccff00] flex-shrink-0" />
                <a
                  href="mailto:hello@brightsolutions.pro"
                  data-testid="footer-email"
                  className="text-zinc-300 hover:text-[#ccff00] transition"
                >
                  hello@brightsolutions.pro
                </a>
              </div>
              <div className="font-mono text-xs text-zinc-500">
                Reg. number: 7011162230
              </div>

              <div className="flex items-center gap-3 pt-2">
                <a
                  href="https://www.instagram.com/brightsolutionseurope?igsh=djc4NTV2b2VtN280&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Bright Solutions Europe on Instagram"
                  data-testid="footer-instagram"
                  className="group inline-flex items-center justify-center h-10 w-10 border border-white/10 text-zinc-300 hover:text-black hover:bg-[#ccff00] hover:border-[#ccff00] transition"
                >
                  <Instagram className="h-4 w-4" strokeWidth={1.75} />
                </a>
                <a
                  href="https://www.linkedin.com/company/bright-solution-europe/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Bright Solutions Europe on LinkedIn"
                  data-testid="footer-linkedin"
                  className="group inline-flex items-center justify-center h-10 w-10 border border-white/10 text-zinc-300 hover:text-black hover:bg-[#ccff00] hover:border-[#ccff00] transition"
                >
                  <Linkedin className="h-4 w-4" strokeWidth={1.75} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-mono text-[11px] text-zinc-600 uppercase tracking-wider">
            © {year} Bright Solutions Europe — brightsolutions.pro
          </p>
          <p className="font-mono text-[11px] text-zinc-600">
            Warsaw · Berlin · London
          </p>
        </div>
      </div>
    </footer>
  );
}
